import politicalStatusFactory from './politicalStatusFactory';

export default politicalStatusFactory({
    prefix: 'data.political.client',
    title: 'Exercez-vous, ou avez-vous exercé depuis moins d’un an une fonction politique,' +
        ' juridictionnelle ou administrative importante ?',
});
